export default __webpack_public_path__ + "static/media/bnb.d42c8231.png";